import request from './base'
//提交新增资产审核
export const propertyAudit = (params) => {
    return request.post("/admin/v1/audit/propertyAudit", params)
}

//查询列表
export const auditList = (params) => {
    return request.post("/admin/v1/audit/list", params)
}

//同意或者拒绝
export const auditOperate = (params) => {
    return request.post("/admin/v1/audit/operate", params)
}

// 销售出库申请
export const outboundAudit = (params) => {
    return request.post("/admin/v1/audit/outboundAudit", params)
}
// 租用申请
export const rentAudit = (params) => {
    return request.post("/admin/v1/audit/rentAudit", params)
}
// 测试申请
export const testAudit = (params) => {
    return request.post("/admin/v1/audit/testAudit", params)
}

//撤销申请
export const auditRepeal = (params) => {
    return request.post("/admin/v1/audit/auditRepeal", params)
}

// 添加车辆到申请
export const addvinsToApply = (params) => {
    return request.post("/admin/v1/audit/addvinsToApply", params)
}

// 归还车辆
export const auditBack = (params) => {
    return request.post("/admin/v1/audit/auditBack", params)
}

// 单独归还车辆
export const singleBack = (params) => {
    return request.post("/admin/v1/audit/singleBack", params)
}

// 调库申请
export const transferAudit = (params) => {
    return request.post("/admin/v1/audit/transferAudit", params)
}

// 更新使用点
export const updateUsagePoint = (params) => {
    return request.post("/admin/v1/audit/updateUsagePoint", params)
}

// 获取有经销商归属的客户
export const getCompaniesWithDealer = () => {
    return request.post("/admin/v1/audit/getCompaniesWithDealer")
}


// WEBPACK FOOTER //
// ./src/api/audit.js